import dynamic from "next/dynamic";

export const DynamicHero048 = dynamic(() => import("./Hero048"), {
  suspenses: true,
});
